import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
    padding: 5px 10px;
    text-align: center;
    background-color: rgb(33, 33, 33);
    color: white;
`;

export default function Footer() {
    return (
        <StyledFooter>
            <span>Copyright &copy; 2018 Paraglide Utah, LLC</span>
        </StyledFooter>
    )
}



// WEBPACK FOOTER //
// ./src/app/Footer.js